"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

// Prevent static generation - may use client-side data
export const dynamic = 'force-dynamic';

export default function IntegrationsPage() {
  const router = useRouter();
  
  useEffect(() => {
    // Redirect to marketplace where integrations are now located
    router.replace("/marketplace");
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-slate-600 dark:text-slate-400">Redirecting to marketplace...</div>
    </div>
  );
}

